import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardSteps,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getLastRodeoConfig = (t: TranslateFunction): GiveawayConfig => {
  const squareImage = staticAssetUrl('v1743019505/the-last-rodeo/last-rodeo-350K-giveaway-sq-img.webp')

  return createBaseConfig({
    theatricalSlug: slugs.sketch,
    heroTitle: t('giveawayHeroTitleLastRodeoV2', 'See The Last Rodeo in Theaters & Get Entries for the $350k Giveaway'),
    logoUrl: angelImagesUrl('v1739566078/last-rodeo-logo-white_t34gvh.webp'),
    inTheatersText: t('inTheatersLastRodeo', 'In theaters May 23rd'),
    videoImage: angelImagesUrl('v1739572486/last-rode-temp-key-wide-03f_1_cem2ka.webp'),

    share: {
      shareText:
        'The upcoming @AngelStudios movie The Last Rodeo in theaters on May. 23rd. Pre-order tickets for as chance to Win the $350k Giveaway! #LastRodeoSweepstakes',
      hashtag: '#LastRodeoSweepstakes',
      shareImage: angelImagesUrl('v1739572142/The-Last-Rodeo---Official-Key-Art---Square---TEXTLESS_jgme9r.webp'),
      shareImageMobile: angelImagesUrl('v1739572142/The-Last-Rodeo---Official-Key-Art---Square---TEXTLESS_jgme9r.webp'),
    },

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.theLastRodeo,
      congratsKey: 'rodeoCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win a $350,000 Adventure Package! Complete your checkout to secure your entries.",
      reservationKey: 'rodeoReservationCompleteText',
      reservationText: "You've earned entries for your chance to win a $350,000 Adventure Package!",
      noShowtimesKey: 'rodeoNowShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, pre-order tickets today for your chance to win the $350k Adventure Package.",
      landscapeImage: squareImage,
      portraitImage: squareImage,
    }),

    steps: [
      ...createStandardSteps(t),
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'preOrderTicketsStep3DescriptionLastRodeoV3',
          "The earlier you pre-order, the more bonus entries you'll get for The Last Rodeo Giveaway",
        ),
      },
    ],

    tabs: createStandardTabs(t),

    prizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420863/imperial-outdoors-trailer-img-01_yft8nz.jpg',
        alt: 'Imperial Outdoors Xplore X195 Travel Trailer',
        title: 'Imperial Outdoors Xplore X195 Travel Trailer',
        value: '$147,000',
        url: 'https://imperial-outdoors.com/',
        sponsorName: 'Imperial Outdoors',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1727735729/Homestead/prizes/bitcoin-01.jpg',
        alt: 'Bitcoin',
        title: '$100,000 in BitCoin',
        value: '$100,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420803/f150-truck-img-01_r9wr47.jpg',
        alt: 'Ford F150 Raptor',
        title: 'Ford F150 Raptor',
        value: '$83,000',
        url: 'https://www.ford.com/trucks/f150/models/f150-raptor/',
        sponsorName: 'Ford',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1744660175/Z252_mower_Salina_KS_2023_071-min_zqwzem.jpg',
        alt: 'Kubota Zero Turn Mower',
        title: 'Kubota - Z252KW-54 - Zero Turn Mower',
        value: '$7,499',
        url: 'https://www.kubotausa.com/',
        sponsorName: 'Kubota',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822684/the-last-rodeo/Clean_WholeBeefStorage-lowres.jpg',
        alt: 'Whole Cow',
        title: 'Whole Cow of Meat with Freezer',
        value: '$6,876',
        sponsorName: 'Whole Cow',
        representativePrizeShown: true,
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822614/the-last-rodeo/0009305_zeon-xp-14-s-110140_625-lowres.jpg',
        alt: 'Warn Winch',
        title: 'Warn ZEON XP 14-S Winch',
        value: '$3,200',
        url: 'https://www.warn.com/',
        sponsorName: 'Warn',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822615/the-last-rodeo/ai-upscale-recovery-kit-lowres.jpg',
        alt: 'Vehicle Recovery Kit',
        title: 'Factor 55 - Vehicle Recovery Kit',
        value: '$1,640',
        url: 'https://factor55.com/',
        sponsorName: 'Factor 55',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1746822614/the-last-rodeo/ultra-hook-lowres.jpg',
        alt: 'Red Ultra Hook',
        title: 'Factor 55 - Red Ultra Hook',
        value: '$280',
        url: 'https://factor55.com',
        sponsorName: 'Factor 55',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420647/AdobeStock_1106386350_y5swrt.jpg',
        alt: 'Gift Card for Ariat Denim',
        title: 'Any Two Pair of Denim Up to $140 Each',
        value: '$280',
        url: 'https://www.ariat.com',
        sponsorName: 'Ariat',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1747153338/F23_MNS_WEST_Montana_Copenhaver_2471_h2zncq.png',
        alt: 'Gift Card for Ariat Cowboy Boots',
        title: 'Any Two Pair of Boots Up to $270 Each',
        value: '$560',
        url: 'https://www.ariat.com',
        sponsorName: 'Ariat',
      },
    ],
    galleryImages: [
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-01.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-02.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-03.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-04.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-05.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-06.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-07.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-08.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-09.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1750712653/sketch/sketch-gal-img-10.webp',
        alt: 'The Last Rodeo Gallery Image',
      },
    ],
    partnerLogos: [
      {
        src: '/v1739480251/partner-logo-imperial-outdoors_ggacqd.png',
        alt: 'imperial-outdoors-logo',
      },
      {
        src: '/v1739480241/partner-logo-factor-55_eegm7d.png',
        alt: 'factor-55-logo',
      },
      {
        src: '/v1739480246/partner-logo-kubota_zv9kmj.png',
        alt: 'kubota-logo',
      },
      {
        src: '/v1739480256/partner-logo-ariat_gnnqab.png',
        alt: 'ariat-logo',
      },
    ],
  })
}
